export const AMOUNT_INSURED_FORMAT = "0,0";
export const AMOUNT_DEFAULT_FORMAT = "0,0.00";
export const PERCENTAGE_FORMAT = "0.0";
export const BREAKDOWN_PERCENTAGE_FORMAT = "0.00";
